import type { ShowEventOptions } from '../config/types';

import { Base } from '../proto/base';
import { ClientEvent as ClientEventV3 } from '../proto/v3/client_event';
import { ClientEvent as ClientEventV2} from '../proto/v2/client_event';
import { getPositiveInteger } from '@/util';

let firstLoad: boolean | undefined = true;
// 如果是undefined 则是已经触发leave事件，需要把enterTime清空，一旦enter，或者visible，则 enterTime 重新赋值
let enterTime: number | undefined = new Date().valueOf();

function getStayLength(beginTime?: number) {
    // enterTime 或者 beginTime有值才进行计算，否则默认为0；
    const begin = beginTime || enterTime;
    if (begin) {
        return getPositiveInteger(new Date().valueOf() - begin);
    }
    return 0;
}

export default (options: ShowEventOptions, isV2: boolean = false): ClientEventV3.EventPackage | ClientEventV2.EventPackage => {
    const {
        type,
        currentUrlPackage,
        referUrlPackage,
        name = '',
        action,
        beginTime,
        params,
        contentPackage,
        status,
        actionType, // 这值目前似乎没传进来
        auto
    } = options;
    const commonInfo = {
        status: status ? (Base.ActionStatus[status] || Base.ActionStatus.UNKNOWN_STATUS) : Base.ActionStatus.SUCCESS,
        [isV2 ? 'show_type' : 'action_type']: actionType ? (Base.ActionType[actionType] || Base.ActionType.UNKNOWN_ACTION_TYPE) : Base.ActionType.CLICK,
        url_package: currentUrlPackage,
        refer_url_package: referUrlPackage,
        [isV2 ? 'content_wrapper' : 'content_package']: contentPackage,
    };
    if (type === 'PV') {
        let sub_action = Base.SubAction.PAGE_ENTER;
        let actionPB = Base.PageShowAction.ENTER;
        let first_load = firstLoad;
        let stay_length = 0;
        firstLoad = false;
        switch (action) {
            case 'leave':
                actionPB = Base.PageShowAction.LEAVE;
                sub_action = Base.SubAction.PAGE_LEAVE;
                stay_length = getStayLength(beginTime);
                enterTime = undefined;
                break;
            case 'enter':
                actionPB = Base.PageShowAction.ENTER;
                sub_action = Base.SubAction.PAGE_ENTER;
                enterTime = new Date().valueOf();
                break;
            case 'visible':
                actionPB = Base.PageShowAction.RESUME;
                sub_action = Base.SubAction.PAGE_RESUME;
                enterTime = new Date().valueOf();
                break;
            case 'hidden':
                actionPB = Base.PageShowAction.LEAVE;
                sub_action = Base.SubAction.PAGE_PAUSE;
                stay_length = getStayLength(beginTime);
                enterTime = undefined;
                break;
        }
        let showType: ClientEventV3.ShowType | ClientEventV2.ShowType = auto ? ClientEventV3.ShowType.PAGE_AUTO : ClientEventV3.ShowType.PAGE_CUSTOM;
        if (isV2) {
            first_load = undefined;
            showType = ClientEventV2.ShowType.PAGE;
        }
        return {
            show_event: {
                action: actionPB,
                sub_action,
                type: showType,
                first_load,
                time_cost: 0,
                stay_length,
                ...commonInfo
            }
        } as ClientEventV3.EventPackage | ClientEventV2.EventPackage
    }
    return {
        show_event: {
            action: isV2 ? 0 : Base.PageShowAction.ENTER,
            type: isV2 ? 0 : ClientEventV3.ShowType.ELEMENT,
            sub_action: isV2 ? 0 : Base.SubAction.PAGE_ENTER,
            element_package: {
                [isV2 ? 'action2': 'action']: name,
                params: JSON.stringify(params),
            },
            ...commonInfo
        }
    }
}
